export default "__VITE_ASSET__BoEZkja4__"